export default __webpack_public_path__ + "static/50th-season-logo-2ab1ee2ad429bbe97a8368180b6b9428.jpg";